import CardTab from "./CardTab";
import CardTabItem from "./CardTabItem";

export {
    CardTab,
    CardTabItem
};
